export const LanguageConfig = {
  skrill: {
    supportedLanguages: [
      'bg', // Bulgarian
      'cz', // Czech
      'da', // Danish
      'de', // German
      'gr', // Greek
      'en', // English
      'us', // English (US)
      'es', // Spanish
      'se', // Spanish (US)
      'fi', // Finish
      'fr', // French
      'it', // Italian
      'jp', // Japanese
      'nl', // Dutch
      'pl', // Polish
      'ro', // Romanian
      'ru', // Russian
      'sv', // Swedish
      'tr', // Turkish
      'cn', // Chinese
      'pt' // Portuguese
    ],
    i18nFiles: new Map<string, string>().set('en', 'assets/skrill/i18n/s-en-GB.json')
  },
  neteller: {
    supportedLanguages: [
      'bg', // Bulgarian
      'cz', // Czech
      'da', // Danish
      'de', // German
      'gr', // Greek
      'en', // English
      'us', // English (US)
      'es', // Spanish
      'se', // Spanish (US)
      'fi', // Finish
      'fr', // French
      'it', // Italian
      'jp', // Japanese
      'nl', // Dutch
      'pl', // Polish
      'ro', // Romanian
      'ru', // Russian
      'sv', // Swedish
      'tr', // Turkish
      'cn', // Chinese
      'pt' // Portuguese
    ],
    i18nFiles: new Map<string, string>().set('en', 'assets/neteller/i18n/n-en-GB.json')
  },
  skrill_and_neteller: {
    supportedLanguages: [
      'bg', // Bulgarian
      'cz', // Czech
      'da', // Danish
      'de', // German
      'gr', // Greek
      'en', // English
      'us', // English (US)
      'es', // Spanish
      'se', // Spanish (US)
      'fi', // Finish
      'fr', // French
      'it', // Italian
      'jp', // Japanese
      'nl', // Dutch
      'pl', // Polish
      'ro', // Romanian
      'ru', // Russian
      'sv', // Swedish
      'tr', // Turkish
      'cn', // Chinese
      'pt' // Portuguese
    ],
    i18nFiles: new Map<string, string>().set('en', 'assets/skrill-and-neteller/i18n/sn-en-GB.json')
  },
  paysafecard: {
    supportedLanguages: [
      'bg', // Bulgarian
      'cz', // Czech
      'da', // Danish
      'de', // German
      'gr', // Greek
      'en', // English
      'us', // English (US)
      'es', // Spanish
      'se', // Spanish (US)
      'fi', // Finish
      'fr', // French
      'it', // Italian
      'jp', // Japanese
      'nl', // Dutch
      'pl', // Polish
      'ro', // Romanian
      'ru', // Russian
      'sv', // Swedish
      'tr', // Turkish
      'cn', // Chinese
      'pt' // Portuguese
    ],
    i18nFiles: new Map<string, string>().set('en', 'assets/paysafecard/i18n/psc-en-GB.json')
  }
};
